interface ConfirmDialogProps {
  message: string;
  title?: string;
  confirmLabel?: string;
  variant?: 'danger' | 'default';
  onConfirm: () => void;
  onCancel: () => void;
}

// Presents as an iOS-style bottom sheet on mobile (slide-up, grab handle, full-width
// stacked actions) and a centered dialog on desktop.
export const ConfirmDialog = ({
  message,
  title = 'Confirm',
  confirmLabel = 'Confirm',
  variant = 'danger',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => (
  <div
    className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/40 backdrop-blur-sm p-0 sm:p-4"
    onClick={onCancel}
  >
    <div
      className="ios-sheet-enter bg-white w-full sm:max-w-sm rounded-t-2xl sm:rounded-xl shadow-2xl px-6 pt-3 pb-[calc(1.5rem+env(safe-area-inset-bottom))] sm:p-6"
      onClick={e => e.stopPropagation()}
    >
      {/* grab handle (mobile only) */}
      <div className="sm:hidden mx-auto mb-4 h-1.5 w-10 rounded-full bg-gray-300" />

      <h3 className="text-base font-semibold text-gray-900 mb-2 text-center sm:text-left">{title}</h3>
      <p className="text-sm text-gray-600 mb-6 text-center sm:text-left">{message}</p>

      <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2.5 sm:gap-3">
        <button
          onClick={onCancel}
          className="min-h-[44px] px-4 py-2.5 sm:min-h-0 sm:py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl sm:rounded-lg hover:bg-gray-200 active:scale-[0.98] transition"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className={`min-h-[44px] px-4 py-2.5 sm:min-h-0 sm:py-2 text-sm font-semibold text-white rounded-xl sm:rounded-lg active:scale-[0.98] transition ${
            variant === 'danger'
              ? 'bg-red-600 hover:bg-red-700'
              : 'bg-primary hover:bg-primary/90'
          }`}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);
